/**
 * MODAL_ACTIONS — single source of truth for all modalAction string values.
 * Use these constants everywhere instead of raw strings to get a compile-time
 * reference and make action names searchable/refactorable.
 *
 * Usage:
 *   import { MODAL_ACTIONS } from "@/utils/constants/modalActions";
 *   uiStore.setModalAction(MODAL_ACTIONS.DELETE_AGENT);
 *   v-if="getModalAction === MODAL_ACTIONS.DELETE_AGENT"
 */

export const MODAL_ACTIONS = {
  // ── Agent ────────────────────────────────────────────────────────────────
  ADD_AGENT: "add_agent",
  EDIT_AGENT: "edit_agent",
  DELETE_AGENT: "delete_agent",
  DUPLICATE_AGENT: "duplicate_agent",
  ASSIGN_PROMPT: "assign_prompt",
  PROMPT_HISTORY: "prompt_history",

  // ── Agent Instructions ────────────────────────────────────────────────────
  ADD_AGENT_INSTRUCTIONS: "add_agent_instructions",
  EDIT_AGENT_INSTRUCTIONS: "edit_agent_instructions",
  DELETE_AGENT_INSTRUCTIONS: "delete_agent_instructions",

  // ── Device / Kiosk ────────────────────────────────────────────────────────
  EDIT_DEVICE: "edit_device",
  GET_DEVICE_INFO: "get_device_info",
  PREVIEW_LOGS: "preview_logs",
  DEVICE_APPS: "device_apps",
  DEVICE_SETTINGS: "device_settings",
  DEVICE_TOKEN: "device_token",
  CLEAR_APP_CACHE: "clear_app_cache",
  CLEAR_APP_DATA: "clear_app_data",
  OPEN_DOOR: "open_door",
  RESTART_APP: "restart_app",
  FORCE_STOP_APP: "force_stop_app",
  REFRESH_FACE_LIBRARY: "refresh_face_library",
  RESTART_DEVICE: "restart_device",
  MASS_RESTART_DEVICES: "mass_restart_devices",
  LAUNCH_APP: "launch_app",
  UNINSTALL_APP: "uninstall_app",
  UNINSTALL_APPS: "uninstall_apps",
  INSTALL_APP: "install_app",
  DEVICE_CONFIGURATION: "device_configuration",
  DE_REGISTER_DEVICE: "deregister_device",
  MOVE_DEVICE: "move_device",
  SCREENSHOT: "screenshot",
  APPLY_JOB: "apply_job",

  // ── Location / Site ───────────────────────────────────────────────────────
  ADD_LOCATION: "add_location",
  EDIT_LOCATION: "edit_location",
  DELETE_LOCATION: "delete_location",
  MOVE_LOCATION: "move_location",
  ADD_STORE: "add_store",
  EDIT_STORE: "edit_store",
  DELETE_STORE: "delete_store",
  SET_SITE_PASSWORD: "set_site_password",
  PASSWORD_HISTORY: "password_history",

  // ── Data Collection ───────────────────────────────────────────────────────
  DELETE_DATA_COLLECTION: "delete_data_collection",
  DELETE_DATA_COLLECTION_URL: "delete_data_collection_url",
  DELETE_DATA_COLLECTION_INTEGRATION: "delete_data_collection_integration",
  MAPPED_FILES: "mapped_files",

  // ── Themes ────────────────────────────────────────────────────────────────
  DELETE_THEME: "delete_theme",
  EDIT_THEME: "edit_theme",
  DUPLICATE_THEME: "duplicate_theme",
  ACTIVATE_THEME_ASSIGNMENT: "activate_theme_assignment",
  DELETE_THEME_ASSIGNMENT: "delete_theme_assignment",
  EDIT_THEME_ASSIGNMENT: "edit_theme_assignment",

  // ── Users ─────────────────────────────────────────────────────────────────
  DELETE_USER: "delete_user",
  EDIT_USER: "edit_user",

  // ── Media ─────────────────────────────────────────────────────────────────
  BULK_DELETE_MEDIA: "bulk_delete_media",

  // ── Configs ───────────────────────────────────────────────────────────────
  DELETE_CONFIG: "delete_config",
  EDIT_CONFIG: "edit_config",

  // ── App Library ───────────────────────────────────────────────────────────
  DELETE_APP: "delete_app",
  EDIT_APP: "edit_app",

  // ── URLs ──────────────────────────────────────────────────────────────────
  ADD_URL: "add_url",
  DELETE_URL: "delete_url",
  EDIT_URL: "edit_url",

  // ── Jobs ──────────────────────────────────────────────────────────────────
  DELETE_JOB: "delete_job",
  DELETE_JOB_REQUEST: "delete_job_request",
  DUPLICATE_JOB: "duplicate_job",

  // ── Campaigns ─────────────────────────────────────────────────────────────
  DELETE_CAMPAIGN: "delete_campaign",

  // ── Data Mapping ──────────────────────────────────────────────────────────
  DELETE_DATA_MAPPING: "delete_data_mapping",
  EDIT_DATA_MAPPING: "edit_data_mapping",

  // ── Integrations ──────────────────────────────────────────────────────────
  CHECK_STORES_AFTER_SUBMIT_VANSAFE_TOKEN: "check_stores_after_submit__vansafe_token",
  CREATE_CUSTOM_INTEGRATION: "create_custom_integration",
};
